<canvas [id]="'barChart'+id"  height="50"></canvas>